<template>
  <div v-if="message" :class="stacked ? 'col justify-center text-center text-caption' : 'row'" class="items-center">
    <div class="col-auto">
      <slot name="actions"></slot>
    </div>
    <div class="col-12">
      <div :class="stacked ? 'justify-center' : 'justify-start'" class="row q-col-gutter-sm items-baseline">
        <div class="col-auto fit" :class="textColor">
          <div class="row q-col-gutter-sm" :class="{ 'justify-center': stacked }">
            <div class="col-12">
              <div class="row q-col-gutter-sm items-center" :class="{ 'justify-center': stacked }">
                <div class="col-auto" :class="{ 'col-12': stacked }">
                  <q-icon v-if="hideIcon === false" :size="iconSize" :color="iconColor" :name="getIcon"></q-icon>
                </div>
                <div :class="dense ? 'col-auto' : 'col-10'">
                  <div class="row">
                    <div class="col-12">
                      <slot name="content" :message="message">
                        {{ message }}
                      </slot>
                    </div>
                    <div class="col-auto">
                      <slot name="sub-content" :subTitle="subTitle">
                        <span class="text-grey-7 text-weight-light">{{ subTitle }}</span>
                      </slot>
                    </div>
                  </div>
                </div>
              </div>
            </div>
            <div class="col-auto q-pl-lg q-ml-md">
              <slot name="bottom-actions"></slot>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>
<script>
export default {
  name: 'Info',
  props: {
    message: {
      type: String,
    },
    subTitle: {
      type: String,
    },
    icon: {
      type: String,
    },
    iconSize: {
      type: [String, Number],
      default: '1.5rem',
    },
    iconColor: {
      type: String,
      default: 'primary',
    },
    stacked: {
      type: Boolean,
      default: false,
    },
    hideIcon: {
      type: Boolean,
      default: false,
    },
    textColor: {
      type: String,
      default: 'text-primary',
    },
    title: {
      type: Boolean,
      default: false,
    },
    dense: {
      type: Boolean,
      default: false,
    },
  },
  computed: {
    getIcon() {
      return this.icon ? this.icon : this.title ? 'label_important' : 'fa fa-info-circle'
    },
  },
}
</script>
